import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { Subscription, combineLatest } from "rxjs";
import {
  DxButtonModule,
  DxDataGridComponent,
  DxDataGridModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTagBoxModule,
  DxTextBoxModule,
  DxToastModule,
} from "devextreme-angular";
import { custom } from "devextreme/ui/dialog";
/* import { BaukostenService } from "src/app/services/baukosten.service"; */
import { ContactsService } from "src/app/services/contacts.service";
import { AppGlobals } from "src/app/app.globals";
import { Router, ActivatedRoute } from "@angular/router";
import { CommonModule } from "@angular/common";
import { SharedComponentsModule } from "src/app/components/shared.components.module";
import { ProjektkostenPopUpComponent } from "src/app/components/projektkosten-pop-up/projektkosten-pop-up.component";
import { ProjectCostsService } from "src/app/services/project-costs.service";
import { environment } from "src/environments/environment";

import * as ExcelJS from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver";
import { TemplatesService } from "src/app/services/templates.service";
import { perUnitLabel } from "src/app/pages/grid-connection/project/project-tabs/project-costs/project-costs-budget/size-unit";
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";
import {
  GpdSegmentedSwitchComponent,
  SegmentOption,
} from "src/app/components/gpd-segmented-switch/gpd-segmented-switch.component";
import {
  BEAUFTRAGT_FILTER_OPTIONS,
  beauftragtFileSlug,
  beauftragtRequestValue,
} from "src/app/constants/beauftragt-filter";
import { ProjectInfoService } from "src/app/services/project-info.service";
import { LoggingService } from "src/app/services/logging.service";
import { GlobalPopupService } from "src/app/components/generic-popup/presets/global-popup/global-popup.service";
import { ProjectCompletePopupComponent } from "src/app/components/project-complete-popup/project-complete-popup.component";
import { ProjectStatus } from "../../../../../../interfaces/entities/project";
import { ActivityLogService } from "src/app/services/activity-log.service";
import { ActivitySection } from "src/app/constants/activity-log";
import { ProjectCostRole } from "src/app/components/projektkosten-pop-up/project-cost-roles";

@Component({
    selector: "app-project-actual-plan",
    templateUrl: "./project-costs-actual.page.html",
    styleUrls: ["./project-costs-actual.page.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        DxDataGridModule,
        DxTagBoxModule,
        DxTextBoxModule,
        DxSelectBoxModule,
        DxButtonModule,
        DxToastModule,
        SharedComponentsModule,
        ProjektkostenPopUpComponent,
        DxPopupModule,
        GpdButtonComponent,
        GpdSegmentedSwitchComponent,
        ProjectCompletePopupComponent,
    ]
})
export class ProjectCostsActualPageComponent implements OnInit, OnDestroy {
  private routeSub: Subscription;
  pl;

  plantsizetext: string = $localize`:@@plantSizeCaps:PLANT SIZE`;

  plantSize: any = "";

  // The area type's unit (WI 3211), e.g. "kWh" - replaces the hardcoded "kWp".
  sizeUnit: any = "";
  // Exposed for the template - perUnitLabel('') must render a bare "€", never a dangling "€/".
  perUnitLabel = perUnitLabel;

  techProjManagerText: string = $localize`TECH. PROJECT MANAGER: `;

  techProjManager: any = "";

  globalUst: number = 19;

  selectedRowKeys: any[] = [];

  originalData: any = [];

  sizeSource: any = "";

  draggedRow: any;

  isRowHovered: boolean = false;

  popupActivate: any = false;
  projectCompletePopupVisible: boolean = false;

  get currentUserName(): string {
    return AppGlobals.LoggedInUserData?.userName ?? '';
  }

  onProjectAutoCompleted(): void {
    this.popupActivate = false;
    this.GetAllProjectCostsForProject();
    this.projectCompletePopupVisible = true;
  }

  editablePermission: any = false;
  projectStatus: string;

  addACostPopUpVisible: any = false;

  editACostPopUpVisible: any = false;

  showAllCategories: any = false;

  toastType: any = "";
  toastMessage: any = "";
  showToast: any = "";

  projektKostenDetailsId: any = "";

  projektKostenDetails: any = "";

  setPopUpType: any = "";

  objectToMove: any = "";

  headerTitles: any = {};

  reOrder: any = "";
  onReOrder: any = "";

  onSaveReveal: boolean = true;

  onUpdateReveal: boolean = false;

  buttonDisabled: boolean = true;

  showButtons: boolean = false;

  isProjectTitleVisible: boolean = false;

  isProjectSelected: boolean = false;

  allowReordering: boolean = false;

  @ViewChild(DxDataGridComponent, { static: false }) grid: DxDataGridComponent;

  currentPageTitle: any = $localize`:@@projectCosts:Projektkosten`;

  disableChanges: boolean = true;

  noData: string = $localize`:@@noData:No Data`;

  baukostenPermission: boolean = false;

  searchTerm: string = "";
  planIdFilter: number | null = null;
  planFilterLabel: string = '';

  readonly labelFilteredBy = $localize`:@@planFilter-filtered:Filtered:`;
  readonly labelShowAll = $localize`:@@planFilter-showAll:Show all`;

  contentLoadedVisible: boolean = true;

  storedDateHolder: any = "";

  gridVisible: boolean = false;

  isVisible = false;
  type = "success";
  message = $localize`:@@changeSaved:Change saved`;

  currentDate = new Date();
  futuredate = new Date(
    this.currentDate.setMonth(this.currentDate.getMonth() + 2)
  );

  pendingClick;

  summaryRow = {
    bemerkung: null,
    bereichId: null,
    bereichName: null,
    details: null,
    detailsMehr: null,
    faellig: this.getFaelligDate(),
    backupFaellig: this.getFaelligDate(),
    id: null,
    istBruttopreis: null,
    istEuroProkWp: null,
    istNettoPreis: null,
    lagerungId: null,
    nettoBrutto: "Netto",
    nochBrutto: null,
    nochUst: null,
    prozAnteil: null,
    sortingIndex: null,
    uNettoPreis: null,
    ust: null,
    zahlbetrag: null,
    zahldatum: null,
  };

  projectData = new Array();
  baukosten: any = [];
  cancelStoreProject = new Array();

  projectId: any;
  highlightCostId: number | null = null;
  projectIdentifier: any;
  projectIdentifierTitle: any;
  projektleiter: any;
  groesse: any;

  istKostenkWp: any = 0;
  istNetto: any = 0;
  ust: any = 0;
  istEuroProkWp: any = 0;
  brutto: any = 0;

  nochUst: any = 0;
  nochBrutto: any = 0;
  aussterhand: any = 0;
  bezahlt: any = 0;
  aussterhandPercentage: any = 0;
  bezahltPercentage: any = 0;

  value: any;

  statuses: any = [
    { id: 1, name: "Netto" },
    { id: 2, name: "Brutto" },
  ];

  categoryList: any = [];
  projectRoles: ProjectCostRole[] = [];

  partnerList: any = [];

  projectCosts: any = {};

  route: any = "";

  routeID: any = "";

  route2: any = "";

  route2ID: any = "";
  milestones: any = [];
  projectMilestones: any[] = [];

  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid: DxDataGridComponent;
  constructor(
    private appGlobals: AppGlobals,
    private projectCostsService: ProjectCostsService,
    private contactsService: ContactsService,
    private templateService: TemplatesService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private projectInfoService: ProjectInfoService,
    private loggingService: LoggingService,
    private globalPopupService: GlobalPopupService,
    private activityLog: ActivityLogService
  ) {
    this.onReorder = this.onReorder.bind(this);
    this.showContextMenu = this.showContextMenu.bind(this);
  }

  async ngOnInit() {
    this.appGlobals.ShowGlobalLoader();
    if (environment.isTestEnvironment === true) {
      this.appGlobals.SetGlobalMenuIndex(2);
    } else {
      this.appGlobals.SetGlobalMenuIndex(2);
    }

    // Subscribe to live param + queryParam observables so re-navigation to a
    // different project (e.g. from the global search) reloads the page correctly.
    this.routeSub = combineLatest([
      this.activatedRoute.paramMap,
      this.activatedRoute.queryParamMap,
    ]).subscribe(([params, queryParams]) => {
      this.route   = params.get("route")   ?? "";
      this.routeID = params.get("routeID") ?? "";
      this.route2  = params.get("route2")  ?? "";
      this.route2ID = params.get("route2ID") ?? "";

      const idParam = params.get("id");
      if (idParam) {
        const newProjectId = parseInt(idParam, 10) || 0;

        this.projectInfoService.getGlobalProjectInfo({ ProjectId: newProjectId }).then(result => {
          // Two quick navigations leave two calls in flight. Without this, the slower reply can
          // name project B's export after project A.
          if (newProjectId !== this.projectId) return;
          if (!result.hasError) {
            this.projectStatus = result.globalProjectInfoResultItem?.status;
            // `title` is the project's PVA; the export is named after it.
            this.projectPva = result.globalProjectInfoResultItem?.title ?? "";
          }
        });

        if (newProjectId !== 0) {
          this.getBaukostenByProjectId({ value: newProjectId });
        }

        this.searchTerm = queryParams.get("search") ?? "";

        const costIdParam = queryParams.get("costId");
        this.highlightCostId = costIdParam ? (parseInt(costIdParam, 10) || null) : null;

        const planIdParam = queryParams.get("planId");
        this.planIdFilter = planIdParam ? (parseInt(planIdParam, 10) || null) : null;

        // This component is reused when the route moves to another project, and DevExtreme
        // keeps its column filterValues across a dataSource swap. Without clearing them, project
        // A's header filters silently narrow project B's grid - and the next filter change on B
        // would persist A's values under B's key.
        if (this.projectId !== newProjectId) {
          this.resetHeaderFilters();
        }
        this.projectId = newProjectId;
        this.activityLog.logView({ Section: ActivitySection.PROJECT_COSTS, ProjectId: newProjectId });
        this.GetAllProjectCostsForProject();
      }
    });

    this.getMilestones();
    this.getProjectMilestones();

    this.projectCosts = {
      siteCost: {
        id: null,
        siteId: this.siteId,
        projectCostCategoryId: null,
        partnerId: null,
        partnerType: "company",
        totalCostNett: 0,
        ust: 0,
        planIsPercentage: false,
        beauftragt: false,
        isDeleted: false,
      },
      paymentPlans: [
        {
          paymentPlanId: null,
          planNr: 1,
          planCostNett: 0,
          planPercentage: 1,
          planPercentageValue: 1,
          planNotes: "",
          discountGross: 0,
          dueDate: this.futuredate,
          costMilestoneId: null,
          dueDateMilestone: false,
          costMilestoneOffset: null,
          costMilestoneDirection: "",
          paidAmountGross: 0,
          paidDate: null,
          dueAmountNett: 0,
          paymentNotes: "",
          paymentPlanIdentifier: null,
          invoiceAvailable: false,
          invoiceNumber: null,
          planCostGross: 0,
          planCostNettValue: 0,
          discountNett: 0,
          dueAmountGross: 0,
          paidAmountNett: 0,
          isDeleted: false,
          //paidDate: this.currentDate,
        },
      ],
      projectCostSplits: [
        {
          paymentPlanId: null,
          projectId: this.projectId,
          projectPercentageSplit: 100,
        },
      ],
    };

    if (AppGlobals.UserPermissions.baukostenPermission === 0) {
      this.baukostenPermission = false;
      this.allowReordering = false;
    } else {
      if (AppGlobals.UserPermissions.baukostenPermission === 1) {
        this.baukostenPermission = false;
        this.allowReordering = false;
      } else {
        this.baukostenPermission = true;
        this.allowReordering = true;
      }
    }

    this.plantSize =
      this.plantsizetext +
      this.sizeSource +
      ":" +
      this.headerTitles.groesse +
      " " +
      this.sizeUnit;
    this.techProjManager =
      this.techProjManagerText + this.headerTitles.projektleiter;
  }
  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
  }

  siteId: any = {};
  readonly beauftragtOptions: SegmentOption[] = BEAUFTRAGT_FILTER_OPTIONS;
  beauftragtFilter = 0;
  /** WI 4945: 1 = only plans with an outstanding amount. Filtered by the API so the header totals match. */
  readonly openOptions: SegmentOption[] = [
    { label: $localize`:@@all:All`, value: 0 },
    { label: $localize`:@@open:Open`, value: 1 },
  ];
  openFilter = 0;
  readonly invoiceHeaderFilter = [
    { text: $localize`:@@withInvoice:With invoice`, value: ['invoiceNumber', '<>', null] },
    { text: $localize`:@@withoutInvoice:Without invoice`, value: ['invoiceNumber', '=', null] },
  ];

  /**
   * Blank cells read as "failed to load", so the no-Schuldner bucket says so instead - but
   * only on data rows. The alignByColumn group summaries make DevExtreme render the category
   * header as a row of cells, and a Schuldner cannot be assigned to a category at all, so
   * labelling that empty cell claimed something the data model does not support.
   */
  debitorCellText = (cellInfo: any): string => {
    if (cellInfo?.target === "group") {
      return "";
    }
    return cellInfo?.value ? cellInfo.value : $localize`:@@withoutDebitor:Without Debitor`;
  };

  /**
   * Header filters the user can narrow the list with. Persisted per project, because a
   * filter that survives a page change but not a reload is worse than none.
   */
  private static readonly FILTER_STORAGE_PREFIX = "projectCostsHeaderFilters:";
  private filtersRestored = false;
  /** Set while this component is the one writing filterValues, so it does not persist its own
   *  clearing and restoring back over what the user actually chose. */
  private applyingStoredFilters = false;

  private get filterStorageKey(): string {
    return `${ProjectCostsActualPageComponent.FILTER_STORAGE_PREFIX}${this.projectId}`;
  }

  /** Saved as {dataField: values}, not DevExtreme's positional state, so reordering or
   *  adding a column later cannot shift someone's stored filter onto a different column. */
  private saveHeaderFilters(grid: any): void {
    if (this.applyingStoredFilters) {
      return;
    }
    const saved: Record<string, any[]> = {};
    for (const column of grid.getVisibleColumns()) {
      const values = column.dataField && grid.columnOption(column.dataField, "filterValues");
      if (values?.length) {
        saved[column.dataField] = values;
      }
    }
    try {
      localStorage.setItem(this.filterStorageKey, JSON.stringify(saved));
    } catch {
      // A full or blocked localStorage must not break filtering itself.
    }
  }

  /** Drops the outgoing project's filters without persisting the empty result over them. */
  private resetHeaderFilters(): void {
    this.filtersRestored = false;
    const grid = this.dataGrid?.instance;
    if (!grid) {
      return;
    }
    this.applyingStoredFilters = true;
    try {
      for (const column of grid.getVisibleColumns()) {
        if (column.dataField && grid.columnOption(column.dataField, "filterValues")) {
          grid.columnOption(column.dataField, "filterValues", null);
        }
      }
    } finally {
      this.applyingStoredFilters = false;
    }
  }

  private restoreHeaderFilters(grid: any): void {
    if (this.filtersRestored) {
      return;
    }
    this.filtersRestored = true;
    let saved: any = null;
    try {
      saved = JSON.parse(localStorage.getItem(this.filterStorageKey) ?? "null");
    } catch {
      saved = null;
    }
    if (!saved || typeof saved !== "object") {
      return;
    }
    this.applyingStoredFilters = true;
    try {
      for (const [dataField, values] of Object.entries(saved)) {
        if (Array.isArray(values) && values.length) {
          grid.columnOption(dataField, "filterValues", values);
        }
      }
    } finally {
      this.applyingStoredFilters = false;
    }
  }

  setBeauftragtFilter(value: number): void {
    this.beauftragtFilter = value;
    this.GetAllProjectCostsForProject();
  }

  setOpenFilter(value: number): void {
    this.openFilter = value;
    this.GetAllProjectCostsForProject();
  }

  GetAllProjectCostsForProject(): void {
    let projectId = {
      ProjectId: this.projectId,
      // The API recomputes the header totals from whatever survives this filter.
      Beauftragt: beauftragtRequestValue(this.beauftragtFilter),
      OnlyOpen: this.openFilter === 1,
    };
    this.projectCostsService.getAllProjectCostsForProject(projectId).then(
      (result) => {
        if (result.hasError === true) {
          AppGlobals.ShowErrorMessage(result.feedback);
        } else {
          this.categoryList = result.costCategories;
          this.projectRoles = result.projectRoles ?? [];
          this.partnerList = result.partnerItems;
          if (this.planIdFilter !== null) {
            this.baukosten = result.overviewItems.filter((item: any) => item.paymentPlanId === this.planIdFilter);
            const match = result.overviewItems.find((item: any) => item.paymentPlanId === this.planIdFilter);
            this.planFilterLabel = match ? match.costCategoryName : `#${this.planIdFilter}`;
          } else {
            this.baukosten = result.overviewItems;
          }
          this.siteId = result.siteId;

          // Size from the area type's size task (WI 3211). 0 means "no size": leave it null so the
          // per-row guards at 1411/1438 skip the division instead of producing Infinity.
          this.headerTitles.groesse = result.projectCostTotals.projectSize || null;
          this.sizeUnit = result.projectCostTotals.sizeUnit ?? "";
          this.plantSize =
            this.plantsizetext +
            this.sizeSource +
            ":" +
            this.headerTitles.groesse +
            " " +
            this.sizeUnit;

          if (isNaN(result.projectCostTotals.totalEuroPerKwP) === true) {
            this.istKostenkWp = "";
          } else {
            this.istKostenkWp = parseFloat(
              result.projectCostTotals.totalEuroPerKwP.toFixed(2)
            ).toLocaleString("de-DE", {
              style: "currency",
              currency: "EUR",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          }
          this.istNetto = parseFloat(
            result.projectCostTotals.totalNettCost.toFixed(2)
          ).toLocaleString("de-DE", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          this.brutto = parseFloat(
            result.projectCostTotals.totalGrossCost.toFixed(2)
          ).toLocaleString("de-DE", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          this.aussterhand = parseFloat(
            result.projectCostTotals.totalOutstandingAmount.toFixed(2)
          ).toLocaleString("de-DE", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          this.bezahlt = parseFloat(
            result.projectCostTotals.totalPaidAmount.toFixed(2)
          ).toLocaleString("de-DE", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          this.aussterhandPercentage =
            parseFloat(
              result.projectCostTotals.totalPercentageOutstanding.toFixed(2)
            ).toLocaleString("de-DE") + "%";
          this.bezahltPercentage =
            parseFloat(
              result.projectCostTotals.totalPercentagePaid.toFixed(2)
            ).toLocaleString("de-DE") + "%";

          for (let i = 0; i < this.baukosten.length; i++) {
            const options = {
              year: "numeric",
              month: "numeric",
              day: "numeric",
            };

            /*             if (this.baukosten[i].paidDate != null || this.baukosten[i].paidDate != undefined) this.baukosten[i].paidDate.toLocaleDateString('de-De', options);
                        if (this.baukosten[i].dueDate != null || this.baukosten[i].dueDate != undefined) this.baukosten[i].dueDate.toLocaleDateString('de-De', options); */
            this.baukosten[i].planUst = this.baukosten[i].planUst / 100;
            this.baukosten[i].planPercentage =
              this.baukosten[i].planPercentage / 100;
            this.baukosten[i].groupDisplay = {
              key: this.baukosten[i].primaryCostCategoryName,
              id: this.baukosten[i].primaryCostCategoryId,
            };
            if (this.baukosten[i].planNr === null) {
              this.baukosten[i].planNrText = "";
            } else {
              this.baukosten[i].planNrText =
                $localize`Abschlag: ` + this.baukosten[i].planNr;
            }

            // console.log(this.baukosten[i].bruttoAmount);
            // console.log(this.baukosten[i].paidAmount);
          }
        }
      },
      (error) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  clearPlanFilter(): void {
    this.planIdFilter = null;
    this.planFilterLabel = '';
    this.GetAllProjectCostsForProject();
  }

  getBaukostenByProjectId(e: any) {
    this.showButtons = true;
    this.searchTerm = "";
    var id: any = {
      ProjectId: e.value,
    };
    this.projectId = e.value;
    this.isProjectTitleVisible = true;
    this.isProjectSelected = true;
  }

  setMissingOrderIndices(e: any) {
    if (e === true) {
      this.onUpdateReveal = true;
      this.onSaveReveal = false;
    }
    for (let i = 0; i <= 11; i++) {
      let index = 0;
      this.baukosten.forEach((element) => {
        if (element.bereichId === i) {
          element.sortingIndex = index;
          index += 1;
        }
      });
    }
  }

  calcCosts() {
    let istkWp = 0;
    let istNetto = 0;
    let ust = 0;
    let istBrutto = 0;
    let nochUst = 0;
    let nochBrutto = 0;

    this.baukosten.forEach((item) => {
      istkWp += item.istEuroProkWp;
      //item.istNettoPreis += 'not a number';
      if (isNaN(item.istNettoPreis) === false) {
        istNetto += parseFloat(item.istNettoPreis);
      } else {
        alert(item.istNettoPreis + ": Is Not a Number");
        return;
      }

      istBrutto += item.istBruttoPreis;
      nochUst += item.nochUst;
      nochBrutto += item.nochBrutto;
    });
    // Same guard as istEuroProkWp below: without a size, per-row istEuroProkWp is never set,
    // so the sum above is NaN - show empty instead of "NaN €" (WI 3211).
    this.istKostenkWp = !this.headerTitles.groesse
      ? ""
      : istkWp.toLocaleString("de-DE", {
          style: "currency",
          currency: "EUR",
        });
    this.istNetto = istNetto.toLocaleString("de-DE", {
      style: "currency",
      currency: "EUR",
    });
    // this.istNetto was just reformatted into a currency string above - divide by the raw
    // local sum instead, and skip the division entirely when there is no size (WI 3211).
    const kWpCalc = this.headerTitles.groesse ? istNetto / this.headerTitles.groesse : null;
    this.istEuroProkWp =
      kWpCalc === null
        ? ""
        : kWpCalc.toLocaleString("de-DE", {
            style: "currency",
            currency: "EUR",
          });
    if (istNetto < istBrutto) {
      this.ust = (istBrutto - istNetto).toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR",
      });
    } else {
      this.ust = "0,00 €";
    }

    this.brutto = istBrutto.toLocaleString("de-DE", {
      style: "currency",
      currency: "EUR",
    });

    this.nochUst = nochUst.toLocaleString("de-DE", {
      style: "currency",
      currency: "EUR",
    });

    this.nochBrutto =
      nochBrutto /* .toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) */;

    this.summaryRow.istEuroProkWp = istkWp;
    this.summaryRow.istNettoPreis = istNetto;
    this.summaryRow.ust = ust;
    this.summaryRow.istBruttopreis = istBrutto;
    this.summaryRow.nochUst = nochUst;
    this.summaryRow.nochBrutto = nochBrutto;
    // this.grid.instance.refresh();
  }

  async checkToastElements() {
    /*     if (this.reOrder !== 'true') {
          if (this.onReOrder !== 'true') {    
            
            }
        } */
    this.toastType = "success";
    this.toastMessage = "Änderungen gespeichert";
    this.showToast = true;
  }
  async initiateSaveChangesToBaukosten() {
    this.onEditActionEnd("");
    await this.checkToastElements();
    this.saveChangesToBaukosten(
      this.toastType,
      this.toastMessage,
      this.showToast
    );
  }

  saveChangesToBaukosten(type: string, message: string, showToast: boolean) {
    this.onUpdateReveal = false;
    this.onSaveReveal = true;

    let payload = {
      projectId: this.projectId,
      baukosten: this.baukosten,
      /*       "UIVersion": AppGlobals.versionNumber, */
    };

    /*     this.service.WriteBaukosten(payload).then(
          async (result) => {
            if (result.hasError === true) {
              AppGlobals.ShowErrorMessage(result.feedback, result, payload, "WriteBaukosten");
    
            } else {
              this.type = type;
              this.message = message;
              this.isVisible = true;
              // this.grid.instance.refresh();
              // console.log('TEST REFRESH');
              let getProject = {
                value: this.projectId
              }
    
              if (getProject.value !== 0 || getProject.value !== '') {
                this.getBaukostenByProjectId(getProject);
              }
              //this.goTo('projektkosten/' + this.projectId);
              //window.location.reload();
            }
          },
          (error) => {
            AppGlobals.ShowErrorMessage(error, error, payload, "WriteBaukosten");
    
            this.appGlobals.setContactIDForAddContractPartner('');
            this.appGlobals.setCompanyIDForAddContractPartner('');
          }); */
  }

  moveToNewCategory(e, categroy) {
    let fromIndex = this.baukosten.findIndex((item) => item == e.row.data);
    this.baukosten[fromIndex].bereichId = categroy;
    this.baukosten[fromIndex].bereichName =
      this.lookupTableBereichsId(categroy);
    // this.grid.instance.refresh();
    this.onUpdateReveal = true;
    this.onSaveReveal = false;
    this.setMissingOrderIndices(this.onUpdateReveal);

    this.toastType = "success";
    this.toastMessage = "Reihe in neue Kategorie verschoben";
    this.showToast = true;
    this.reOrder = "true";
    //this.saveChangesToBaukosten('success', 'Reihe in neue Kategorie verschoben', true);
  }

  //--------------------------  DATAGRID EVENTS -------------------------------

  onGridContentReady(e: any): void {
    this.restoreHeaderFilters(e.component);
    if (this.highlightCostId == null) return;
    if (e.component.totalCount() === 0) return; // data not loaded yet — wait for next firing
    const costId = this.highlightCostId;
    this.highlightCostId = null;
    e.component.expandAll(-1);
    this.selectedRowKeys = [costId];
    e.component.navigateToRow(costId);
  }

  onCellClick(e) {
    this.onUpdateReveal = true;
    this.onSaveReveal = false;
  }

  updateProjectDetail(): void {
    this.onUpdateReveal = true;
    this.onSaveReveal = false;
  }

  onReorder(e) {
    this.showAllCategories = true;

    const visibleRows = e.component.getVisibleRows();

    let toIndex;
    let fromIndex;
    let categoryTo: any;

    if (visibleRows[e.toIndex].rowType == "data") {
      toIndex = this.baukosten.findIndex(
        (item) => item === visibleRows[e.toIndex].data
      );
      fromIndex = this.baukosten.findIndex((item) => item === e.itemData);
      categoryTo = this.baukosten[toIndex].bereichId;
    }

    if (visibleRows[e.toIndex].rowType == "group") {
      if (e.fromIndex < e.toIndex) {
        toIndex = this.baukosten.findIndex(
          (item) => item === visibleRows[e.toIndex + 1].data
        );
      }
      if (e.toIndex < e.fromIndex) {
        toIndex = this.baukosten.findIndex(
          (item) => item === visibleRows[e.toIndex - 1].data
        );
      }

      fromIndex = this.baukosten.findIndex((item) => item === e.itemData);
      categoryTo = this.baukosten[toIndex].bereichId;
    }

    this.baukosten[fromIndex].bereichId = categoryTo;
    this.baukosten[fromIndex].bereichName =
      this.lookupTableBereichsId(categoryTo);

    this.baukosten.splice(fromIndex, 1);
    this.baukosten.splice(toIndex, 0, e.itemData);
    this.onUpdateReveal = true;
    this.onSaveReveal = false;
    this.setMissingOrderIndices(this.onUpdateReveal);
    this.toastType = "success";
    this.toastMessage = "Reihe verschoben";
    this.showToast = true;
    this.reOrder = "true";
    //this.saveChangesToBaukosten('success', 'Reihe verschoben', true);
  }

  //---------------------------- CONTEXT MENU --------------------------

  showContextMenu(e) {
    try {
      if (e.row.rowType === "data") {
        e.items = [
          {
            text: "einfügen unter",
            onItemClick: () => {
              let insertAtItem = e.row.data;
              const insertAtIndex = this.baukosten.findIndex(
                (item) => item === insertAtItem
              );
              let category = e.row.key.bereichId;

              let newRow = {
                bemerkung: null,
                bereichId: category,
                bereichName: this.lookupTableBereichsId(category),
                details: null,
                detailsMehr: null,
                faellig: this.getFaelligDate(),
                backupFaellig: this.getFaelligDate(),
                id: null,
                istBruttopreis: null,
                istEuroProkWp: null,
                istNettoPreis: null,
                lagerungId: null,
                nettoBrutto: "Netto",
                nochBrutto: null,
                nochUst: null,
                prozAnteil: null,
                sortingIndex: null,
                uNettoPreis: null,
                ust: null,
                zahlbetrag: null,
                zahldatum: null,
              };

              this.baukosten.splice(insertAtIndex + 1, 0, newRow);

              // wait a moment for ui to catch up

              setTimeout(() => {
                this.grid.instance.editCell(e.row.rowIndex + 1, "details");
              }, 20);
              this.setMissingOrderIndices(this.onUpdateReveal);
            },
            onClick: () => {
              this.onUpdateReveal = true;
              this.onSaveReveal = false;
            },
          },
          {
            text: "löschen",
            onItemClick: () => {
              if (this.projectStatus === ProjectStatus.COMPLETED) {
                this.globalPopupService.showWarningPopup(this.completedProjectWarning);
                return;
              }
              this.onUpdateReveal = true;
              this.onSaveReveal = false;
              e.component.deleteRow(e.row.rowIndex);
              e.component.confirmDelete = false;
              this.setMissingOrderIndices(this.onUpdateReveal);
              this.onEditActionEnd("");
              //  this.grid.instance.refresh();
            },
          },
          {
            text: "einfügen in neuer Kategorie",
            items: this.getItems(e, 0),
            onClick: () => {
              this.onUpdateReveal = true;
              this.onSaveReveal = false;
            },
          },
          {
            text: "verschieben in neue Kategorie",
            items: this.getItems(e, 1),
            onClick: () => {
              this.onEditActionEnd("");
              // this.grid.instance.refresh();
              this.onUpdateReveal = true;
              this.onSaveReveal = false;
            },
          },
        ];
      }
    } catch (Exception) {
      e.items = [
        {
          text: "einfügen in neuer Kategorie",
          items: this.getItems(e, 0),
        },
      ];
    }
  }

  getItems(e, mode) {
    let usedCategories = [];

    this.baukosten.forEach((element) => {
      if (!usedCategories.includes(element.bereichId)) {
        usedCategories.push(element.bereichId);
      }
    });

    let items = [];
    for (let i = 0; i <= 11; i++) {
      if (!usedCategories.includes(i)) {
        items.push({
          text: this.lookupTableBereichsId(i),
          onItemClick: () => {
            if (mode == 0) {
              this.insertNewCategory(i);
            }
            if (mode == 1) {
              this.moveToNewCategory(e, i);
            }
          },
        });
      }
    }
    return items;
  }

  insertNewCategory(category) {
    let newRow = {
      bemerkung: null,
      bereichId: category,
      bereichName: this.lookupTableBereichsId(category),
      details: null,
      detailsMehr: null,
      faellig: this.getFaelligDate(),
      backupFaellig: this.getFaelligDate(),
      id: null,
      istBruttopreis: null,
      istEuroProkWp: null,
      istNettoPreis: null,
      lagerungId: null,
      nettoBrutto: "Netto",
      nochBrutto: null,
      nochUst: null,
      prozAnteil: null,
      sortingIndex: 0,
      uNettoPreis: null,
      ust: null,
      zahlbetrag: null,
      zahldatum: null,
      /*       UIVersion: AppGlobals.versionNumber, */
    };

    this.baukosten.push(newRow);
    // this.grid.instance.refresh();

    setTimeout(() => {
      this.onUpdateReveal = true;
      this.onSaveReveal = false;
      // console.log(this.grid.instance.getVisibleRows());
      // console.log(newRow);
      const index = this.grid.instance
        .getVisibleRows()
        .findIndex((item) => item.data === newRow);
      this.grid.instance.editCell(index, "details");
    }, 200);
    this.setMissingOrderIndices(this.onUpdateReveal);
  }

  insertAllCategories(category) {
    let newRow = {
      bereichId: category,
      bereichName: this.lookupTableBereichsId(category),
    };

    this.baukosten.push(newRow);
    // this.grid.instance.refresh();

    setTimeout(() => {
      this.onUpdateReveal = true;
      this.onSaveReveal = false;
      // console.log(this.grid.instance.getVisibleRows());

      const index = this.grid.instance
        .getVisibleRows()
        .findIndex((item) => item.data === newRow);
      this.grid.instance.editCell(index, "details");
    }, 200);
    this.setMissingOrderIndices(this.onUpdateReveal);
  }
  //----------------------- FORMATTING --------------------------

  formatEuro(value: number): string {
    if (isNaN(value)) {
      return "";
    }
    //return value + ' €';
    return value.toLocaleString("de-DE", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  formatDate(value) {
    const options = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    };
    return value.toLocaleDateString("de-De", options);
  }

  formatPercentage(value) {
    return value.toLocaleString("de-DE") + " %";
  }

  //----------------------- UTILITY -----------------------------

  getFaelligDate() {
    let currentDate = new Date();
    //currentDate.setMonth(currentDate.getMonth() + 2);
    new Date(currentDate.setMonth(currentDate.getMonth() + 2));
    /*     console.clear();
        console.log(currentDate); */
    return currentDate;
  }

  lookupTableBereichsId(input) {
    switch (input) {
      case 0:
        return "Baustelle";

      case 1:
        return "Module";

      case 2:
        return "Wechselrichter";

      case 3:
        return "Trafo";

      case 4:
        return "DC Montage";

      case 5:
        return "AC Montage";

      case 6:
        return "Monitoring / DV / Fernwirk";

      case 7:
        return "E.Tech Infra.";

      case 8:
        return "GU";

      case 9:
        return "Projektentwicklung";

      case 10:
        return "Pacht / Sanierung";

      case 11:
        return "Abnahme & Sonstiges";
    }
    return "Zusammenfassung";
  }

  lookupTableBereichsName(input) {
    switch (input) {
      case "Baustelle":
        return 0;

      case "Module":
        return 1;

      case "Wechselrichter":
        return 2;

      case "Trafo":
        return 3;

      case "DC Montage":
        return 4;

      case "AC Montage":
        return 5;

      case "Monitoring / DV / Fernwirk":
        return 6;

      case "E.Tech Infra.":
        return 7;

      case "GU":
        return 8;

      case "Projektentwicklung":
        return 9;

      case "Pacht / Sanierung":
        return 10;

      case "Abnahme & Sonstiges":
        return 11;
    }
    return "--- --- ---";
  }

  doSearch(e: any): void {
    console.log(e);
    this.contentLoadedVisible = false;
    this.searchTerm = e.value;
    if (this.searchTerm.length < 2) {
      if (this.grid) {
        this.grid.instance.searchByText("");
        this.appGlobals.setSearchPanelText("");
        this.contentLoadedVisible = true;
      }
      return;
    } else {
      this.grid.instance.searchByText(this.searchTerm);
      this.appGlobals.setSearchPanelText(this.searchTerm);
      this.contentLoadedVisible = true;
    }
  }

  checkGlobalSearchText(): void {
    if (AppGlobals.searchPanelText === "") {
      //  this.appGlobals.HideGlobalLoader();
      this.gridVisible = true;
      return;
    } else {
      if (this.grid) {
        this.searchTerm = AppGlobals.searchPanelText;
        var item = {
          value: "",
        };
        item.value = this.searchTerm;
        this.doSearch(item);
        //  this.appGlobals.HideGlobalLoader();
        this.gridVisible = true;
      } else {
        setTimeout(() => {
          this.checkGlobalSearchText();
        }, 1000);
      }
    }
  }

  saveQueryOnCancel(): void {
    this.baukosten = JSON.parse(JSON.stringify(this.originalData));
    this.grid.instance.cancelEditData();
    this.reloadTotalCalculations();
    this.onUpdateReveal = false;
    this.onSaveReveal = true;
  }

  reloadTotalCalculations(): void {
    this.onEditActionEnd("");
    /*     this.istKostenkWp = this.istKostenkWp ;
        this.istNetto = this.istNetto;
        this.ust = this.ust;
        this.brutto = this.brutto;
        this.nochUst = this.nochUst;
        this.nochBrutto = this.nochBrutto; */
  }

  goTo(path: string): void {
    this.router.navigate([path]);
  }

  setGridHeight() {
    const containerDiv = document.getElementById("baukostenContainer");

    const headerContainerDiv = document.getElementById(
      "baukostenHeaderContainerId"
    );

    const containerHeight = containerDiv.clientHeight;
    //const windowHeight = window.innerHeight;
    const gridHeaderHeight = headerContainerDiv.clientHeight;
    const availableHeight = containerHeight - gridHeaderHeight - 40;
    let height = availableHeight;

    if (height > 36) {
      return height;
    } else {
      height = 250;
      return height;
    }
  }

  togglePopUpVisibility(e: any): void {
    this.popupActivate = e;
    this.GetAllProjectCostsForProject();
  }

  getSelectedCategory(e: any): void {
    // console.log(e);
    this.insertNewCategory(e.index);
  }

  onDragStart(event: any): void {
    // console.log('START');
    this.draggedRow = event.data;
    let categoryListContainer = document.getElementById("categoryListID");
    categoryListContainer.className = "projektkosten-all-categories-start";
  }
  onDragEnd(): void {
    // console.log('END');
    let categoryListContainer = document.getElementById("categoryListID");
    categoryListContainer.className = "projektkosten-all-categories-end";
  }

  getSelectedID(e: any): void {
    this.objectToMove = e.data;
  }

  animateCategoryDiv() {
    return "projektkosten-all-categories-start";
  }

  onDragMove(event: any): void {
    const gridElement = document.querySelector(".dx-datagrid") as HTMLElement;
    const gridRect = gridElement.getBoundingClientRect();

    const isOutsideGrid =
      event.event.clientX < gridRect.left ||
      event.event.clientX > gridRect.right - 300 ||
      event.event.clientY < gridRect.top ||
      event.event.clientY > gridRect.bottom;

    if (isOutsideGrid) {
      event.cancel = true;
      // console.log('released');
      this.isProjectSelected = event.itemData;
    }
  }

  onRowMouseOver(rowIndex: any): void {
    // console.log('MOUSE-OVER: ', rowIndex)
    this.isRowHovered[rowIndex] = true;
  }

  onRowMouseOut(rowIndex: any): void {
    // console.log('MOUSE-OUT: ', rowIndex)
    this.isRowHovered[rowIndex] = false;
  }

  onRowDragLeave(event: any): void {
    // console.log('event1:: ', event);
    // Clear the hoveredRowIndex when a row is dragged out
    //this.hoveredRowIndex = null;
  }

  onRowDragEnter(event: any): void {
    // console.log('event2:: ', event);
  }

  onEditActionBegin(e: any): void {
    if (e.data && e.data.allowEditing === false) {
      e.cancel = true;
      return;
    }
    if (this.projectStatus === ProjectStatus.COMPLETED) {
      e.cancel = true;
      this.globalPopupService.showWarningPopup(this.completedProjectWarning);
      return;
    }
    if (this.projectStatus === ProjectStatus.INACTIVE || this.projectStatus === ProjectStatus.CANCELED) {
      e.cancel = true;
      this.globalPopupService.showWarningPopup(this.pausedProjectWarning);
      return;
    }
    this.onUpdateReveal = true;
    this.onSaveReveal = false;
  }

  private get completedProjectWarning(): string {
    return $localize`:@@editCompletedProjectWarning:The project is complete. To make changes, set the status of the project to "Active".`;
  }

  private get pausedProjectWarning(): string {
    return this.projectStatus === ProjectStatus.INACTIVE
      ? $localize`:@@editInactiveProjectWarning:The project is inactive. To make changes, set the status of the project to "Active".`
      : $localize`:@@editCanceledProjectWarning:The project is canceled. To make changes, set the status of the project to "Active".`;
  }

  handleOptionChange(e: any): void {
    if (e.value === "Brutto") {
      //  console.log('BRUTTO');
      //  console.log(e);
    } else {
      //  console.log('NETTO');
      //  console.log(e);
    }
  }

  onEditActionEnd(e: any): void {
    if (e.data != undefined) {
      //UI AUTOMATIC CALCULATIONS
      this.appGlobals.ShowGlobalLoader();
      for (let i = 0; i < this.baukosten.length; i++) {
        if (this.baukosten[i].nettoBrutto === "Netto") {
          this.baukosten[i].ust = 0;
        } else {
          if (this.baukosten[i].ust === null) {
            this.baukosten[i].ust = this.globalUst;
          } else {
            if (this.baukosten[i].ust == 0) {
              this.baukosten[i].ust = this.globalUst;
            }
          }

          if (this.baukosten[i].nochBrutto === 0) {
            this.baukosten[i].faellig = null;
          } else {
            if (this.baukosten[i].backupFaellig === null) {
              this.baukosten[i].backupFaellig = this.getFaelligDate();
            }
            if (this.baukosten[i].faellig === null) {
              this.baukosten[i].faellig = this.baukosten[i].backupFaellig;
            }
          }
        }

        if (this.baukosten[i].nettoBrutto === "Brutto") {
          if (this.baukosten[i].ust === null) {
            this.baukosten[i].ust = this.globalUst;
          } else {
            if (this.baukosten[i].ust == 0) {
              this.baukosten[i].ust = this.globalUst;
            }
          }

          this.baukosten[i].istBruttoPreis =
            this.baukosten[i].istNettoPreis +
            this.baukosten[i].istNettoPreis * (this.baukosten[i].ust / 100);

          let taxPaid =
            this.baukosten[i].zahlbetrag -
            this.baukosten[i].zahlbetrag / (this.baukosten[i].ust / 100 + 1);
          taxPaid = parseFloat(taxPaid.toFixed(2));
          let totalTaxDue =
            this.baukosten[i].istBruttoPreis - this.baukosten[i].istNettoPreis;

          this.baukosten[i].nochUst = totalTaxDue - taxPaid;

          if (this.baukosten[i].lagerungId != null) {
            this.baukosten[i].nochBrutto = 0;
          } else {
            this.baukosten[i].nochBrutto =
              this.baukosten[i].istBruttoPreis - this.baukosten[i].zahlbetrag;
          }

          if (this.baukosten[i].nochBrutto === 0) {
            this.baukosten[i].faellig = null;
          } else {
            if (this.baukosten[i].backupFaellig === null) {
              this.baukosten[i].backupFaellig = null; //this.getFaelligDate();
            }
            if (this.baukosten[i].faellig === null) {
              this.baukosten[i].faellig = this.baukosten[i].backupFaellig;
            }
          }

          if (this.headerTitles.groesse != null) {
            this.baukosten[i].istEuroProkWp =
              this.baukosten[i].istNettoPreis / this.headerTitles.groesse;
          }
        } else {
          this.baukosten[i].ust = 0;
          this.baukosten[i].istBruttoPreis = this.baukosten[i].istNettoPreis;
          this.baukosten[i].nochUst = null;

          if (this.baukosten[i].lagerungId != null) {
            this.baukosten[i].nochBrutto = 0;
          } else {
            this.baukosten[i].nochBrutto =
              this.baukosten[i].istBruttoPreis - this.baukosten[i].zahlbetrag;
          }

          if (this.baukosten[i].nochBrutto === 0) {
            this.baukosten[i].faellig = null;
          } else {
            if (this.baukosten[i].backupFaellig === null) {
              this.baukosten[i].backupFaellig = this.getFaelligDate();
            }
            if (this.baukosten[i].faellig === null) {
              this.baukosten[i].faellig = this.baukosten[i].backupFaellig;
            }
          }

          if (this.headerTitles.groesse != null) {
            this.baukosten[i].istEuroProkWp =
              this.baukosten[i].istNettoPreis / this.headerTitles.groesse;
          }
        }
      }
      this.calcCosts();
      //  this.appGlobals.HideGlobalLoader();
    }
    // this.grid.instance.refresh();
  }

  changeSelectedPartner(e: any): void {
    /*     console.log(e.value);
        this.changeAgentObject.newAgentId = e.value; */
  }

  getMilestones(): void {
    this.templateService.getMilestones({}).then((result) => {
      this.milestones = result.milestonesResultItems;
    });
  }

  getProjectMilestones(): void {
    this.projectInfoService
      .getProjectHeaddata({ ProjectHeaddataItem: { projectId: this.projectId } })
      .then((result) => {
        if (!result.hasError && result.projectHeaddataItem?.milestones) {
          this.projectMilestones = result.projectHeaddataItem.milestones;
        }
      });
  }

  addCost(): void {
    if (this.projectStatus === ProjectStatus.COMPLETED) {
      this.globalPopupService.showWarningPopup(this.completedProjectWarning);
      return;
    }
    if (this.projectStatus === ProjectStatus.INACTIVE || this.projectStatus === ProjectStatus.CANCELED) {
      this.globalPopupService.showWarningPopup(this.pausedProjectWarning);
      return;
    }
    this.projectCosts = {
      siteCost: {
        id: null,
        siteId: this.siteId,
        projectCostCategoryId: null,
        partnerId: null,
        partnerType: "company",
        totalCostNett: 0,
        ust: 0,
        planIsPercentage: false,
        beauftragt: false,
        isDeleted: false,
      },
      paymentPlans: [
        {
          planPercentage: 1,
          planPercentageValue: 1,
          paymentPlanId: null,
          planNr: 1,
          planCostNett: 0,
          planNotes: "",
          discountGross: 0,
          dueDate: this.futuredate,
          costMilestoneId: null,
          dueDateMilestone: false,
          costMilestoneOffset: null,
          costMilestoneDirection: "",
          paidAmountGross: 0,
          paidDate: null,
          dueAmountNett: 0,
          paymentNotes: "",
          paymentPlanIdentifier: null,
          invoiceAvailable: false,
          invoiceNumber: null,
          planCostGross: 0,
          planCostNettValue: 0,
          discountNett: 0,
          dueAmountGross: 0,
          paidAmountNett: 0,
          isDeleted: false,
          //paidDate: this.currentDate,
        },
      ],
      projectCostSplits: [
        {
          paymentPlanId: null,
          projectId: this.projectId,
          projectPercentageSplit: 100,
        },
      ],
    };
    console.log(
      "projectCosts",
      this.projectCosts,
      this.projectCosts.paymentPlans
    );
    if (AppGlobals.UserPermissions.baukostenPermission != 0) {
      /*  this.appGlobals.setProjectCostSaveHolder(''); */
      this.popupActivate = true;
    } else {
      return;
    }

    this.currenttitle = this.addProjectCostTitle;
  }
  selectedRowData: any = {};
  editProjektKosten(e: any): void {
    if (this.projectStatus === ProjectStatus.INACTIVE || this.projectStatus === ProjectStatus.CANCELED) {
      this.globalPopupService.showWarningPopup(this.pausedProjectWarning);
      return;
    }
    // this.appGlobals.setProjectCostSaveHolder('');
    if (AppGlobals.UserPermissions.baukostenPermission != 0) {
      if (
        this.baukostenPermission === true ||
        AppGlobals.UserPermissions.baukostenPermission === 1
      ) {
        // console.log(e);
        if (e.rowType === "group") {
          return;
        } else {
          this.projektKostenDetailsId = e.data.paymentPlanId;
          //    console.log(this.projektKostenDetailsId);
          this.getProjektKosten();
          this.selectedRowData = e.data;
        }
      } else {
        return;
      }
    } else {
      return;
    }

    this.currenttitle = this.editProjectCostTitle;
  }

  getProjektKosten(): void {
    let projektKosten = {
      //"CostId": this.projektKostenDetailsId,
      PaymentPlanId: this.projektKostenDetailsId,
      ProjectId: this.projectId,
    };

    this.projectCostsService.getPaymentPlansForEditing(projektKosten).then(
      (result) => {
        if (result.hasError === true) {
          AppGlobals.ShowErrorMessage(result.feedback);
        } else {
          console.log("selectedRowData: ", this.selectedRowData);
          this.projectCosts.siteCost = result.siteCost;
          this.projectCosts.siteCost.partnerName =
            this.selectedRowData.partnerName;
          this.projectCosts.siteCost.siteId = this.siteId;
          if (
            this.projectCosts.siteCost.partnerType === undefined ||
            !this.projectCosts.siteCost.partnerType
          )
            this.projectCosts.siteCost.partnerType = "company";
          this.projectCosts.paymentPlans = result.paymentPlans;
          this.popupActivate = true;
        }
      },
      (error) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  getCategoryDisplay(e: any): any {
    console.log(e);
    let displayText = e.groupDisplay.key;
    if (e.groupDisplay.key === null || e.groupDisplay.key === undefined) {
      return $localize`Unknown`;
    } else {
      return displayText;
    }
  }

  exportCosts(): void {
    console.log("EXPORTED: Doesn't do anything yet");
  }

  currenttitle: string = "Current title";
  addProjectCostTitle: string = $localize`:@@addProjectCost:Add Project Cost`;
  editProjectCostTitle: string = $localize`:@@editProjectCost:Edit Project Cost`;

  hidePopUp(): void {
    this.popupActivate = false;
  }
  onGridOptionChanged(event: any) {
    // fullName looks like columns[3].filterValues
    if (event.fullName?.endsWith(".filterValues")) {
      this.saveHeaderFilters(event.component);
    }
    if (event.fullName?.endsWith(".sortOrder")) {
      this.syncGroupOrderWithSort(event.component);
    }
    if (event.name === "summary") {
      // Check if it is specific to your summary
      const summary = event.component
        .getController("summary")
        .getTotalSummaryValue("planEuroPerKilowattPeak");
      console.log("Summary Updated: ", summary);
      this.planEuroPerKilowattPeakTotal(summary);
    }
  }

  private readonly groupSummaryColumns = [
    "planEuroPerKilowattPeak",
    "planCostNettDisplay",
    "planCostGross",
    "discountGross",
    "paidAmountNett",
    "paidAmountGross",
    "dueAmountNett",
    "dueAmountGross",
  ];

  // Column sorting only orders rows within a group; the groups themselves are ordered by
  // key unless sortByGroupSummaryInfo points at a group summary.
  private syncGroupOrderWithSort(grid: any) {
    const sorted = this.groupSummaryColumns
      .map((dataField) => ({
        dataField,
        sortOrder: grid.columnOption(dataField, "sortOrder"),
        sortIndex: grid.columnOption(dataField, "sortIndex") ?? Number.MAX_SAFE_INTEGER,
      }))
      .filter((c) => c.sortOrder)
      .sort((a, b) => a.sortIndex - b.sortIndex)[0];

    const next = sorted
      ? [{ summaryItem: sorted.dataField, sortOrder: sorted.sortOrder }]
      : [];
    const current = grid.option("sortByGroupSummaryInfo") ?? [];
    if (
      current[0]?.summaryItem === next[0]?.summaryItem &&
      current[0]?.sortOrder === next[0]?.sortOrder
    ) {
      return;
    }
    grid.option("sortByGroupSummaryInfo", next);
  }

  planEuroPerKilowattPeakTotal(totalValue: any) {
    // Do something with the total value
    console.log("Total:", totalValue);
  }

  /** The project's PVA, loaded alongside the status. Empty until that call returns. */
  projectPva = "";

  /**
   * Same convention as the cost overview's export. exportDataGrid reads the grid's visible
   * rows, so the header filters already decide what lands in the file.
   */
  private exportFileName(): string {
    const today = new Date().toISOString().slice(0, 10);
    // PVAs are free text and reach the filesystem, so path characters have to go. Falls back
    // to the id rather than producing "Projektkosten__2026-09-22_alle.xlsx" if it is missing.
    const project =
      this.projectPva.replace(/[\\/:*?"<>|]/g, "-").trim() || `Projekt-${this.projectId}`;
    return `Projektkosten_${project}_${today}_${beauftragtFileSlug(
      this.beauftragtFilter
    )}${this.openFilter === 1 ? "_offen" : ""}.xlsx`;
  }

  async exportAsExcel(e) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet($localize`Project Cost List`);
    const fileName = this.exportFileName();

    exportDataGrid({
      component: this.dataGrid.instance,
      worksheet: worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: "application/octet-stream" }), fileName);
        this.loggingService.logFileExport(buffer, fileName, {
          section: ActivitySection.PROJECT_COSTS,
          projectId: Number(this.projectId) || null,
          siteId: Number(this.siteId) || null,
        });
      });
    });

    return;
  }
}
